<script setup lang="ts">
import { ref } from "vue";
import { useRouter } from "vue-router";
const router = useRouter();
const showRegister = import.meta.env.VITE_CONFIG_SHOW_REGISTER === "true";
const showLogin = import.meta.env.VITE_CONFIG_SHOW_LOGIN === "true";

function loginBtn() {
  router.push({ name: "login" });
}

function registerBtn() {
  router.push({ name: "login" });
}
</script>

<template>
  <div class="text-primary flex">
    <button
      v-if="showLogin"
      class="btn-n-border w-[5em] xl:w-[6em] mr-[1em]"
      type="submit"
      @click="loginBtn"
    >
      <p class="text-primary text-[14px] font-bold">
        {{ $t("Header.Login") }}
      </p>
    </button>
    <button v-if="showRegister" class="btn-y-border w-[5em] xl:w-[6em]" @click="registerBtn">
      <p class="text-secondary text-[14px] font-bold py-1">
        {{ $t("Header.Register") }}
      </p>
    </button>
  </div>
</template>
